import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  padding-left: 0;
`

export const TimelineLine = styled.div`
  position: absolute;
  left: 40px;
  top: 20px;
  bottom: 60px;
  width: 2px;
  background: var(--border-light);

  @media (max-width: 768px) {
    display: none;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  color: var(--text-secondary);

  p {
    margin: 0;
    font-size: 14px;
  }
`
